const configS3 = (bucketName, dirName) => {
  return {
    bucketName: bucketName,
    dirName: dirName || "data" /* optional */,
    region: "ap-southeast-1",
    accessKeyId: "AKIAVLDCOUNBJUPM7NQ3",
    secretAccessKey: "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",
  };
};

export default configS3;
